import { useEffect } from "react"

const useScript = (
  id: string,
  src: string,
  type: string,
  async: boolean,
  cbid: string,
  blockingMode: string
) => {
  useEffect(() => {
    const script = document.createElement("script")

    script.id = id
    script.src = src
    async ? (script.async = async) : (async = false)
    script.type = getScriptType(type)
    cbid && script.setAttribute("data-cbid", cbid)
    blockingMode && script.setAttribute("data-blockingmode", blockingMode)

    document.getElementById(id + "-script").appendChild(script)
    return () => {
      if (
        document.getElementById(id + "-script") &&
        document.getElementById(id + "-script").hasChildNodes()
      ) {
        document.getElementById(id + "-script").removeChild(script)
      }
    }
  }, [id, src, type, async, cbid, blockingMode])

  function getScriptType(scriptType: string) {
    switch (scriptType) {
      case "javascript":
        return "text/javascript"
      case null:
        return null
    }
  }
}

export default useScript
